type BehavioralLayerT = {
  eyebrow: string;
  title: React.ReactNode;
  body: string;
  layer1: string;
  layer2: string;
  layer3: string;
};

const defaultT: BehavioralLayerT = {
  eyebrow: "Section 06 — The big vision",
  title: <>The <em className="urgent">behavioral layer</em> of collaborative work and learning.</>,
  body: "CSW combines collaborative workspaces with behavioral engagement intelligence to better understand how people focus, collaborate, and engage over time.",
  layer1: "COLLABORATIVE WORKSPACES",
  layer2: "BEHAVIORAL ENGAGEMENT SIGNALS",
  layer3: "OVER TIME · LONGITUDINAL CONTEXT",
};

function LayerStack({ t }: { t: BehavioralLayerT }) {
  const w = 600, h = 220;
  return (
    <svg viewBox={`0 0 ${w} ${h}`} className="w-full h-full" preserveAspectRatio="none" aria-hidden="true">
      <g>
        <rect x="0" y="20"  width={w} height="50" fill="hsl(var(--primary))" opacity="0.18" />
        <rect x="0" y="85"  width={w} height="50" fill="hsl(var(--secondary))" opacity="0.18" />
        <rect x="0" y="150" width={w} height="50" fill="hsl(var(--muted-foreground))" opacity="0.12" />
      </g>
      <polyline
        points="0,180 80,160 160,130 240,115 320,90 400,70 480,55 560,40 600,32"
        fill="none"
        stroke="hsl(var(--primary))"
        strokeWidth="1.8"
      />
      <text x="14" y="46"  fontSize="10" fill="currentColor" opacity="0.7" letterSpacing="3">{t.layer1}</text>
      <text x="14" y="111" fontSize="10" fill="currentColor" opacity="0.7" letterSpacing="3">{t.layer2}</text>
      <text x="14" y="176" fontSize="10" fill="currentColor" opacity="0.7" letterSpacing="3">{t.layer3}</text>
    </svg>
  );
}

export const BehavioralLayer = ({ t = defaultT }: { t?: BehavioralLayerT }) => {
  return (
    <section className="py-28 lg:py-36 border-t border-border/40 relative overflow-hidden" aria-labelledby="vision-title">
      <div className="container relative mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid lg:grid-cols-12 gap-12 items-end">
          <div className="lg:col-span-7">
            <span className="eyebrow-neon">{t.eyebrow}</span>
            <h2 id="vision-title" className="mt-4 font-display text-4xl sm:text-5xl lg:text-6xl leading-[1.05] text-foreground">
              {t.title}
            </h2>
            <div className="hairline w-32 mt-8 mb-6" />
            <p className="text-lg text-muted-foreground leading-relaxed max-w-2xl">
              {t.body}
            </p>
          </div>
          <div className="lg:col-span-5">
            <LayerStack t={t} />
          </div>
        </div>
      </div>
    </section>
  );
};
